/**
 * Created by admin on 2017/3/23.
 */
import { GetDepartmentList, AddDepartment, DelDepartment, GetDepartmentById, UpdateDepartment } from '@api/organization.js';
import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import Tree from 'Tree';

module.exports = {
    components: { Tree },
    created: function() {
        this.getList();
    },
    data() {
        return {
            needExpendId: [1],
            seletbmId: "",
            DataList: [],
            ActionOrginize: {}, //内容页选ss中节点值
            ActionParament: {}, //弹窗选中节点值
            selectedCell: {},
            ActionParamentDialog: {}, //弹窗选中节点值
            dialogVisible: false, //新增修改
            organizationVisible: false, //选择部门
            DepartmentName: "", //部门名称
            update: false, //是否更新
            dialogTitle: "", //新增修改弹窗标题
        }
    },
    computed: {
        sysSid() {
            return this.$store.state.sysSid;
        },
        sysSession() {
            return this.$store.state.sysSession;
        }
    },
    methods: {
        handleCurrentChange: function(val) {}, //分页监听页面
        getList() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession
            };
            GetDepartmentList(Params).then(res => {
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                util.doResult(this, res, () => {
                    this.DataList = Data;
                });
            });
        },
        handleNodeClick(data) {
            this.ActionOrginize = data;
            this.seletbmId = this.ActionOrginize.Id;
        }, //页面选中节点
        handleActionClick(data) {
            if (data.Id == this.ActionParament.Id) {
                this.$message({
                    message: '上级机构不能选择自己！',
                    type: 'warning'
                });
                this.ActionParamentDialog.Id = "";
                this.ActionParamentDialog.D_Name = "";
                return;
            }
            this.ActionParamentDialog.Id = data.Id;
            this.ActionParamentDialog.D_Name = data.D_Name;
        }, //弹窗选中节点
        del() {

            if (JSON.stringify(this.ActionOrginize) == "{}") {
                this.$message({
                    message: '尚未选择组织部门',
                    type: 'warning'
                });
                return;
            }

            this.$confirm('确认删除吗？', '提示', {}).then(() => {
                var Params = { "Id": this.ActionOrginize.Id };
                DelDepartment(Params).then(res => {
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "删除成功",
                            type: 'success'
                        });
                        this.getList();
                    });
                });
            });

        },
        submit() {

            this.needExpendId = [1];
            if (this.update) {

                if (this.ActionParamentDialog.Id == this.ActionParament.Id) {
                    this.$message({
                        message: '上级机构不能选择本身！',
                        type: 'warning'
                    });
                    return;
                }

                if ($.trim(this.ActionParamentDialog.Id).length == 0) {
                    this.$message({
                        message: '请选择一个上级机构！',
                        type: 'warning'
                    });
                    return;
                }

                let Params = { "D_Name": this.DepartmentName, "ParentId": this.ActionParamentDialog.Id, "Id": this.ActionParament.Id };
                this.needExpendId.push(this.ActionParament.Id);
                jToast.show({
                    type: "loading",
                    text: "正在提交数据，请稍后...",
                    time: -1
                });
                UpdateDepartment(Params).then(res => {
                    jToast.close();
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "更新成功",
                            type: 'success'
                        });
                        this.update = false;
                        this.dialogVisible = false;
                        this.getList();
                        this.ActionOrginize = {};
                    })
                });
            } else {
                let Params = { "D_Name": this.DepartmentName, "ParentId": this.ActionParamentDialog.Id };
                this.needExpendId.push(this.ActionParamentDialog.Id);
                jToast.show({
                    type: "loading",
                    text: "正在提交数据，请稍后...",
                    time: -1
                });
                AddDepartment(Params).then(res => {
                    jToast.close();
                    util.doResult(this, res, () => {
                        this.$notify({
                            title: '成功',
                            message: "添加成功",
                            type: 'success'
                        });
                        this.update = false;
                        this.dialogVisible = false;
                        this.getList();
                        this.ActionOrginize = {};
                    });
                });
            }
        },
        handleEdit() {
            this.dialogTitle = "修改";
            if (JSON.stringify(this.ActionOrginize) == "{}") {
                this.$message({
                    message: '尚未选择组织部门',
                    type: 'warning'
                });
                return;
            }
            let Params = { "Sid": this.sysSid, "Session": this.sysSession, "Id": this.ActionOrginize.Id };
            jToast.show({
                type: "loading",
                text: "正在获取数据，请稍后...",
                time: -1
            });
            GetDepartmentById(Params).then(res => {
                jToast.close();
                util.doResult(this, res, () => {});
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                if (Data.ParentId == 0) {
                    this.$message({
                        message: '请选择部门',
                        type: 'warning'
                    });
                    return;
                }
                this.DepartmentName = Data.D_Name;
                this.dialogVisible = true;
                this.update = true;

                this.ActionParament.Id = Data.Id;
                this.ActionParamentDialog = {};
                this.ActionParamentDialog.Id = Data.ParentId;
                this.ActionParamentDialog.D_Name = Data.P_Name;

            });
        },
        addHandle() {
            this.dialogTitle = "新增";
            this.dialogVisible = true;
            this.update = false;
            this.DepartmentName = "";
            this.ActionParament = {};
            this.ActionParamentDialog = {};
        },
        Actiondialog() {
            this.dialogVisible = false;
            this.ActionParament = {};
            this.ActionParamentDialog = {};
            this.update = false;
        },
        originDialog() {
            this.ActionParament = {};
            this.ActionParamentDialog = {};
            this.organizationVisible = false;
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/personManage/organization/organization.js